export function BrandLogo({ size = 24 }: { size?: number }) {
  return (
    <div style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
      <span
        style={{
          width: size,
          height: size,
          borderRadius: 8,
          background: "var(--accent)",
          color: "var(--accent-ink)",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "var(--display)",
          fontWeight: 500,
          fontSize: size * 0.55,
        }}
      >
        R
      </span>
      <span style={{ fontFamily: "var(--ui)", fontWeight: 700, fontSize: size * 0.6, letterSpacing: -0.2 }}>
        Ride4Baker
      </span>
    </div>
  );
}
